import { render, staticRenderFns } from "./baidu-age.vue?vue&type=template&id=3d542558"
import script from "./baidu-age.vue?vue&type=script&lang=js"
export * from "./baidu-age.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports